export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  getMyTeamsNames($state, $getters) {
    return $getters.getMyTeams.map(team => team.name.toLowerCase()) || [];
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
  getTeamsAvailability: state => {
    const availabilityMap = {};
    
    // Check if state.records exists and is an array
    if (Array.isArray(state.records)) {
      state.records.forEach(team => {
        availabilityMap[team.id] = team.available_for_conversation;
      });
    } else if (state.records && typeof state.records === 'object') {
      // If it's an object, iterate through its values
      Object.values(state.records).forEach(team => {
        if (team && team.id) {
          availabilityMap[team.id] = team.available_for_conversation;
        }
      });
    }
    
    return availabilityMap;
  }
};
